import { createApp } from 'vue';
import http from './plugins/http';
import BuyBox  from '../components/single/BuyBox.vue';
import PassBuyBox  from '../components/single/PassBuyBox.vue';
import Reviews from '../components/single/Reviews.vue';

/**
 * single.js - монтирует Vue компоненты на single странице.
 *
 * window.productData инжектится из single.volt:
 * {
 *   id, slug, price, sale_price,
 *   is_auth, is_owned,
 *   buy_box, reviews_section
 * }
 */
document.addEventListener( 'DOMContentLoaded', () => {

    const data = window.productData;
    if ( !data ) return;

    const props = {
        product: {
            id:         data.id,
            slug:       data.slug,
            name:       data.name,
            price:      data.price,
            sale_price: data.sale_price,
            emoji:      data.emoji,
        },
        buyBox: data.buy_box,
        owned:  data.is_owned || false,
        toolkitUrl: data.toolkit_url || '',
    }

    if( document.getElementById('vPassBuyBox') ) {
        createApp( PassBuyBox, props ).use(http).mount('#vPassBuyBox');
    }

    if( document.getElementById('vBuyBox') ) {
        createApp( BuyBox, props ).use(http).mount('#vBuyBox');
    }

    if( document.getElementById('vReviews') ) {
        createApp( Reviews, {
            section:   data.reviews_section,
            productId: data.id,
        } ).use(http).mount('#vReviews');
    }

} );